import React from 'react'
import {
    Box,
    Button,
    Center,
    Drawer,
    DrawerBody,
    DrawerCloseButton,
    DrawerContent,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    Text,
    useColorMode,
    useColorModeValue,
    useDisclosure,
    VStack,
} from '@chakra-ui/react'
import { HamburgerIcon } from '@chakra-ui/icons'
import { LIGHT_THEME } from '../../lib/constants'
import MobileMenu from './MobileMenu'
import Logo from '../../uielements/Logo'
import { Link } from 'gatsby'
import { useTranslation } from 'react-i18next'
import { FaEnvelope, FaGoogle, FaPhone } from 'react-icons/fa'

const DrawerMenu = () => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const closeIconColor = useColorModeValue('brand.blue', 'brand.yellow')
    const hamburgerMenuColor = useColorModeValue('brand.blue', 'brand.blue')
    const { t } = useTranslation()
    const logoColor = useColorModeValue('blue', 'white');

    return (
        <>
            <Button onClick={onOpen} variant={'transparent'} ml={0} pl={0}>
                <HamburgerIcon
                    boxSize={10}
                    viewBox={'0 0 24 24'}
                    color={hamburgerMenuColor}
                />
            </Button>
            <Drawer placement={'left'} onClose={onClose} isOpen={isOpen} size={'xl'}>
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton top={1} right={1} w={16} h={16} fontSize={'3xl'} color={closeIconColor} />
                    <DrawerHeader borderBottomWidth="1px" py={4} px={2}>
                        <Box display={'flex'}>
                            <Logo width="130" color={logoColor} />
                        </Box>
                    </DrawerHeader>
                    <DrawerBody p={0}>
                        <MobileMenu />
                    </DrawerBody>
                    <DrawerFooter borderTopWidth="1px" py={2} px={0}>
                        <VStack alignItems="center" w={'100%'}>
                            <Box fontSize={'sm'}>
                                <Button
                                    w={'full'}
                                    maxW={'md'}
                                    leftIcon={<FaEnvelope />}
                                    onClick={() => window.open('mailto:em@bougas-school.gr', '_blank')}
                                >
                                    <Center>
                                        <Text>&nbsp; {t('contact.email_1_display')}</Text>
                                    </Center>
                                </Button>
                            </Box>
                            <Box fontSize={'sm'}>
                                <Button
                                    w={'full'}
                                    maxW={'md'}
                                    leftIcon={<FaPhone />}
                                    onClick={() => window.open('tel:+302721092022', '_blank')}
                                >
                                    <Center>
                                        <Text>&nbsp; {t('contact.phone_1_display')}</Text>
                                    </Center>
                                </Button>
                            </Box>
                            <Box fontSize={'sm'} textAlign={'right'} lineHeight={1}>
                                <Button
                                    w={'full'}
                                    maxW={'md'}
                                    leftIcon={<FaGoogle />}
                                    variant={'outline'}
                                    onClick={() => window.open('https://bit.ly/bougas-school', '_blank')}
                                >
                                    <Center>
                                        <Text>&nbsp; {t('contact.address')}</Text>
                                    </Center>
                                </Button>
                            </Box>
                        </VStack>
                    </DrawerFooter>
                </DrawerContent>
            </Drawer>
        </>
    )
}

export default DrawerMenu
